import { Box, styled } from '@mui/material';

const StyledOverviewProfileDetailsContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(2),
  // Card real (misma receta que los mosaicos del plan) para que la ficha no quede flotando
  // sobre la sección: en claro es blanca sobre gris, en oscuro es un escalón sobre el lienzo.
  backgroundColor: theme.palette.surface.raised,
  border: `1px solid ${theme.palette.hairline.main}`,
  borderRadius: '16px',
  boxShadow: theme.palette.shadow.card,
  // Móvil: foto arriba centrada, info debajo (para que no se vea apretada).
  // Desktop (md+): se conserva la disposición en fila.
  flexDirection: 'column',
  minWidth: 0,
  padding: theme.spacing(2.5, 2),
  marginBottom: theme.spacing(3),
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    marginBottom: theme.spacing(5),
    padding: theme.spacing(3),
    textAlign: 'left'
  }
}));

export default StyledOverviewProfileDetailsContainer;
